export const getGlycerinArticleIdFromSku = (sku: string) => sku.split('-').slice(0, 1).join('-');
